export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-foreground-950 text-background-300">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-base text-background-50"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-100">吃瓜网站</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              专注吃瓜视频网站合集，提供热门吃瓜视频在线观看、最新网红吃瓜视频爆料、每日吃瓜视频更新，吃瓜视频大全一站式平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '关于我们', href: '#about' },
                { label: '焦点专题', href: '#carousel' },
                { label: '视频合集', href: '#index' },
                { label: '热门话题', href: '#topics' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">更多内容</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热搜榜单', href: '#ranking' },
                { label: '最新快讯', href: '#updates' },
                { label: '精彩视频', href: '#media' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-600">更多合作伙伴信息即将上线，敬请期待。</p>
          </div>
        </div>

        <div className="pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {currentYear} 吃瓜网站 - 专注吃瓜视频网站合集。本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-foreground-600 hover:text-primary-400 transition-colors">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}